import { render, staticRenderFns } from "./ProviderModal.vue?vue&type=template&id=274226f3"
import script from "./ProviderModal.vue?vue&type=script&lang=js"
export * from "./ProviderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports